import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ajaxservice } from '../../../../../app/services/ajaxservice';
import { Router } from '@angular/router';

@Component({
  selector: 'kt-raisecomplaint',
  templateUrl: './raisecomplaint.component.html',
  styleUrls: ['./raisecomplaint.component.scss']
})
export class RaisecomplaintComponent implements OnInit {

  @Input() modal_properties

  note: string = '';
  loadingAdd: Boolean = false;
  successraise_message: string  = '';
  ticketId: any;

  constructor(
    private modalService: NgbModal,
    private toastr: ToastrService,
    public ajax: ajaxservice,
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  formatDate() {
    let d = new Date(), month = '' + (d.getMonth() + 1), day = '' + d.getDate(), year = d.getFullYear();
    return [year.toString().padStart(2, '0'), month.toString().padStart(2, '0'), day.toString().padStart(2, '0')].join('-');
  }

  closemodal() {
    this.modalService.dismissAll();
  }

  raiseticket(modal) {
    this.loadingAdd = true;
    var preferred_date = this.formatDate();
    var data = {
      customer_code: this.modal_properties.customer_code,
      customer_contract_id: this.modal_properties.customer_contract_id,
      product_id: this.modal_properties.product_id,
      product_sub_id: this.modal_properties.product_sub_id,
      model_no: this.modal_properties.model_no,
      part_number: this.modal_properties.part_number,
      serial_no: this.modal_properties.serial_no,
      end_userdetails_id: this.modal_properties.end_userdetails_id,
      billing_address_id: this.modal_properties.billing_address_id,
      call_category_id: 1,
      cust_preference_date: preferred_date,
      contract_type_id: this.modal_properties.contract_type_id,
      work_type_id: 3,
      problem_desc: this.note,
      service_category: 3,
      image: '',
      priority: 'P1',
      raised_by: localStorage.getItem('unreg_mob'),
    }
    var url = 'cus_raise_ticket/';
    this.ajax.postdata(url, data).subscribe(data => {
      if (data['response'].response_code == "200") {
        this.loadingAdd = false;
        this.modalService.dismissAll();
        this.modalService.open(modal, {
          size: 'lg', //specifies the size of the dialog box
          windowClass: "center-modalsm",
          backdrop: 'static',
          keyboard: false
        });                       //to open modal success pop-up
        this.successraise_message = data['response'].message;
        this.ticketId = data['response'].ticket_id     //add new parameter by harish Mar25-2025
      }
      else if (data['response'].response_code == "400" || data['response'].response_code == "500") {
        this.loadingAdd = false;
        this.toastr.error(data['response'].message, 'Error');        //toastr message for error
      }
      else {
        this.loadingAdd = false;
      }
    }, (err) => {
      this.loadingAdd = false;
      console.log(err);                                             //prints if it encounters an error
    });
  }
  route():void{
    window.location.reload()    
  }
}
